import { Button } from '@src/atoms/Button';
import { TButtonView, TSize } from '@src/models/common';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { classnames } from '@src/utils/classnames';
import { getClass } from '@src/utils/getClass';
import React, { FC, useContext } from 'react';
import { TAlignButton } from '../models';
import styled from './ShowMoreButton.module.scss';

interface IShowMoreButtonProps {
  /**
   * Центровка кнопки "показать еще"
   * */
  align?: TAlignButton;

  /**
   * Не будет создавать отдельную строку
   */
  inline?: boolean;

  /** Вид кнопки */
  view?: TButtonView;

  /** Размер кнопки */
  size?: TSize;

  /** Раскрыт ли контент */
  isShowAll?: boolean;

  /** Использовать ли уменьшенный отступ между контентом и кнопкой (8px) */
  useSmallBtnPadding?: boolean;

  /** Обработчик нажатия кнопки */
  onClick: () => void;
}

export const ShowMoreButton: FC<IShowMoreButtonProps> = ({
  align = 'left',
  view = 'textLight',
  size,
  inline,
  isShowAll,
  useSmallBtnPadding,
  onClick,
}) => {
  const { isMobile } = useContext(BreakpointsContext);

  const moreBtnClasses = classnames(
    styled.moreBtn,
    getClass(styled, 'alignButton', align + (isMobile ? 'Mobile' : 'Desktop')),
    {
      [styled.inlineMoreBtn]: inline,
      [styled.hideBtn]: isShowAll,
      [styled.smallBtnPadding]: useSmallBtnPadding,
      [styled.notTextButton]: !['textLight', 'textDark'].includes(view),
    },
  );

  return (
    <div className={moreBtnClasses}>
      <Button
        onClick={onClick}
        view={view}
        size={size || (isMobile ? 'sm' : 'md')}
        type={'button'}
        id={'showMoreBtn'}
        postIcon={view === 'textLight' ? 'arrow' : undefined}
      >
        {isShowAll ? 'Скрыть' : 'Показать еще'}
      </Button>
    </div>
  );
};
